<div class="form-group mt-0">
    <div class="row">
        <div class="col">
            <label class="input-label">{{ 'settings.externalInstances' | translate }}</label>
            <div class="table-items">
                <div class="item item-header">
                    <div class="row">
                        <div class="col-6 align-items-center justify-content-start">{{ 'settings.Instance' | translate }}</div>
                        <div class="col-2 align-items-center justify-content-middle"></div>
                        <div class="col-1 align-items-center justify-content-middle">{{ 'settings.BPAFE' | translate }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ 'settings.BPABE' | translate }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ 'settings.DS' | translate }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ 'settings.GDB' | translate }}</div>
                    </div>
                </div>
                <div class="item highlight">
                    <div class="row">
                        <div class="col-6 align-items-center justify-content-start">{{ instanceURL }}</div>
                        <div class="col-2 align-items-center justify-content-middle"></div>
                        <div class="col-1 align-items-center justify-content-middle">{{ feVersion }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ beVersion }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ dsBeVersion }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ dsBeVersion }}</div>
                    </div>
                </div>
                <div class="item" *ngFor="let instance of instances;">
                    <div class="row">
                        <div class="col-6 align-items-center justify-content-start">{{ instance.host }}</div>
                        <div class="col-2 align-items-center justify-content-middle">
                            <button class="editBtn" (click)="publishInstanceSettings(instance.id)">
                                {{ 'Publish settings' | translate }}
                            </button>
                        </div>
                        <div class="col-1 align-items-center justify-content-middle">{{ instance.feVersion }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ instance.beVersion }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ instance.dsBeVersion }}</div>
                        <div class="col-1 align-items-center justify-content-middle">{{ instance.gdbVersion }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>